export const circulationMotoData = {
  path: '/circulation-moto',
  breadcrumb: [
    ['Épreuves pratiques', '/epreuves'],
    ['Circulation moto', '/circulation-moto'],
  ],
  kicker: 'Épreuve circulation · 30 minutes',
  title: 'Circulation moto',
  titleHighlight: "l'examen sur route.",
  subtitle:
    "30 minutes de conduite réelle, 31 critères évalués, score minimum 17/31. La dernière étape pour valider ton permis A1 ou A2.",
  seoTitle: 'Circulation moto — Déroulement, critères, notation 31 points (ETM 2026)',
  seoDescription:
    "Épreuve circulation moto (permis A1/A2) : 30 min de conduite, 31 critères d'évaluation, score minimum 17/31. Déroulement, conseils ECSR, erreurs éliminatoires.",
  seoKeywords:
    'circulation moto, examen circulation moto, permis a2 circulation, 31 critères circulation, examen route moto, in-com moto, conduite examen moto, trajectoires examen moto',
  heroImage:
    'https://images.unsplash.com/photo-1558981852-426c6c22a060?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Motard en conduite urbaine pour l\'examen circulation',
  duration: '30 minutes de conduite',
  cost: 'Inclus dans le forfait moto-école',
  timeRequired: 'PT30M',
  about: 'Épreuve circulation, permis A1, permis A2, 31 critères',
  primaryCta: { label: 'Voir les 9 thèmes ETM', to: '/revision' },
  secondaryCta: { label: 'Plateau — 6 manœuvres', to: '/epreuves/plateau' },
  relatedTopic: 'circulation-moto',

  intro:
    "<p>L'épreuve <strong>circulation</strong> est la <strong>dernière marche</strong> du permis A1 ou A2. Après avoir validé l'ETM (Code moto) et le plateau, tu prends la route <strong>30 minutes</strong> avec un inspecteur en moto derrière toi (interphone obligatoire).</p><p>L'évaluation porte sur <strong>31 critères</strong> répartis en 4 grands blocs : <em>vérifications avant départ</em>, <em>conduite</em>, <em>perception du danger</em>, <em>partage de la route</em>. Score de réussite : <strong>17 points minimum sur 31</strong>. Les erreurs éliminatoires (feu rouge, refus de priorité, excès grave) entraînent un échec immédiat.</p>",

  conditions: [
    {
      title: 'Plateau validé',
      text: "Le plateau (6 manœuvres) doit avoir été réussi avant de présenter la circulation. Les deux épreuves sont indépendantes mais séquentielles.",
    },
    {
      title: '12h de conduite minimum',
      text: "En moto-école, 12 heures de circulation réelle sont obligatoires (sur les 20h totales du forfait légal). En moyenne, 15-20h sont nécessaires pour atteindre le niveau examen.",
    },
    {
      title: 'Équipement obligatoire',
      text: 'Casque homologué ECE 22-06, gants CE, blouson avec protections, pantalon adapté, chaussures montantes. Sans cet équipement, l\'examen est refusé.',
    },
    {
      title: 'Moto adaptée à ta catégorie',
      text: "125 cm³ (pour A1) ou moto 35 kW max (pour A2). Une moto plus puissante en A2 = examen invalide.",
    },
  ],

  steps: [
    {
      title: 'Vérifications avant départ',
      duration: '2 minutes',
      text: "Niveaux (huile, refroidissement), pneus (pression + usure), feux, freins. L'inspecteur peut te poser une question mécanique (la liste officielle est publique). Bonne réponse = points gagnés.",
    },
    {
      title: 'Mise en route + interphone',
      duration: '3 minutes',
      text: "Démarrage propre, ajustement rétroviseurs, test interphone avec l'inspecteur. Premiers mètres en parking : montre que tu es à l'aise sur la moto.",
    },
    {
      title: 'Conduite en agglomération',
      duration: '10-15 minutes',
      text: 'Trajectoires de sécurité (élargir avant les virages), respect des priorités, contrôle visuel sur 360°, courtoisie envers les autres usagers. C\'est là que tombent la plupart des échecs.',
    },
    {
      title: 'Conduite hors agglomération / voie rapide',
      duration: '10-15 minutes',
      text: "Allure adaptée à la route, dépassements sécurisés, anticipation des intersections. L'inspecteur te demande parfois de prendre une bretelle d'autoroute ou de te garer.",
    },
    {
      title: 'Bilan + résultat',
      duration: '2 minutes',
      text: "Retour sur le centre d'examen. Le résultat n'est PAS donné immédiatement — tu le reçois sous 48h via le site de la Sécurité routière ou par mail. Patience !",
    },
  ],

  erreurs: [
    {
      title: 'Brusquer les commandes',
      text: 'Accélérations sèches, freinages tardifs, embrayage à coups : signes d\'inexpérience. Sois fluide, anticipe.',
    },
    {
      title: 'Oublier les contrôles visuels',
      text: "Avant chaque changement de direction : rétro intérieur + contrôle angle mort (tourner la tête). 1 oubli = -1 point.",
    },
    {
      title: 'Mauvaises trajectoires en virage',
      text: "Rentrer trop à l'intérieur du virage = danger. Trajectoire de sécurité : large à l'entrée, regard loin sur la sortie, accélérer en sortie.",
    },
    {
      title: 'Stress éliminatoire',
      text: "Brûler un feu rouge ou un stop par stress = échec immédiat. Respire, prends ton temps, l'inspecteur n'est pas là pour te piéger.",
    },
  ],

  conseils: [
    'Repasse plusieurs fois sur les routes du centre d\'examen avec ton moniteur — tu connaitras les pièges habituels.',
    "Apprends par cœur le \"in-com moto\" (les 12 questions mécanique avant départ) : c'est offert.",
    "Pratique la conduite sous la pluie en formation : si l'examen tombe un jour humide, tu seras confiant.",
    'Pense \"trajectoire de sécurité\" en boucle : large, ralenti, regard loin, accélération en sortie.',
    "Si tu rates : garde la motivation. Le taux de réussite au 2ᵉ passage est très supérieur (tu connais le format).",
  ],

  faq: [
    {
      q: 'Quelle est la durée de l\'épreuve circulation moto ?',
      a: '30 minutes de conduite réelle (parfois 25 selon les centres). Avec les vérifications avant départ, le briefing initial et le bilan final, compte 45 minutes au total.',
    },
    {
      q: 'Combien de points faut-il avoir pour réussir ?',
      a: '17 points minimum sur 31. Chaque critère est noté 0, 1, 2 ou 3 (selon sa gravité). Les erreurs éliminatoires (E sur la grille) entraînent un échec automatique même avec un score élevé.',
    },
    {
      q: 'Quelles sont les erreurs éliminatoires ?',
      a: 'Feu rouge ou stop non respecté, refus de priorité, franchissement de ligne continue, excès de vitesse > 10 km/h, conduite dangereuse, intervention de l\'inspecteur pour éviter un accident, chute. Toute erreur E = échec, peu importe le score.',
    },
    {
      q: 'Si je rate la circulation, dois-je repasser le plateau ?',
      a: 'NON. Si tu as validé le plateau, il reste valable 3 ans. Tu n\'as plus qu\'à repasser la circulation. Même chose dans l\'autre sens : si tu rates le plateau, le plateau seul est à repasser.',
    },
    {
      q: 'Quand reçoit-on le résultat de l\'examen ?',
      a: 'Sous 48h en moyenne. Tu reçois un mail (ou notification SMS) avec ton CEPC (Certificat d\'Examen du Permis de Conduire) si tu as réussi. Ce document fait office de permis provisoire pendant 4 mois (le temps de recevoir le permis officiel).',
    },
    {
      q: 'Peut-on demander un parcours spécifique à l\'examen ?',
      a: 'Non, l\'inspecteur décide du parcours selon les conditions du jour (météo, trafic, travaux). Il peut te demander de te diriger vers une zone précise mais c\'est lui qui choisit la route.',
    },
  ],

  sourceLabel:
    'Programme officiel ETM 2026 (REMC), arrêté du 23 avril 2012 modifié, Sécurité routière.',
  sourceUrl: 'https://www.securite-routiere.gouv.fr/passer-son-permis-de-conduire/permis-moto',
};
